import { ChangeEvent } from 'react';
import { useKnnStore } from '../dal/knn-store';
import { IKnnParameters } from '../knn-interfaces';
import { jsonStringify } from '../../../../../domain/openu-provider';
import { DistanceType } from '../../../cluster/cluster-interfaces';

const KnnParameters = () => {

    const params = useKnnStore(store => store.params);
    const setParams = useKnnStore(store => store.setParams);

    const distance = useKnnStore(store => store.distance);
    const setDistance = useKnnStore(store => store.setDistance);

    const onParametersChange = (evt: ChangeEvent<HTMLTextAreaElement>) => {
        const value = evt.target.value;

        let parsed: IKnnParameters|null = null;

        try{
            parsed = JSON.parse(value);
        }
        catch(err){
            console.log(err);
        }

        if(!parsed) return;

        setParams(parsed);
    };

    const onDistanceChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        const value = evt.target.value;
        const distance = Number(value);
        setDistance(distance);
    };

    return (
        <div className="flex flex-col" style={{
            height: '500px',
            width: '300px',
        }}>
            <select
                className="mb-4 px-4 py-2 rounded"
                value={ distance }
                onChange={ onDistanceChange }>
                <option value={ DistanceType.Manhattan }>Manhattan</option>
                <option value={ DistanceType.Euclidean }>Euclidean</option>
            </select>

            <div className="mb-1 font-bold">JSON</div>

            {/*<select
                className="mb-4 px-4 py-2 rounded"
                value={ linkage }
                onChange={ onLinageChange }>
                <option value={ LinkageType.SingleLinkage }>Single Linkage</option>
                <option value={ LinkageType.CompleteLinkage }>Complete Linkage</option>
            </select>

            <select
                className="mb-4 px-4 py-2 rounded"
                value={ distance }
                onChange={ onDistanceChange }>
                <option value={ DistanceType.Manhattan }>Manhattan</option>
                <option value={ DistanceType.Euclidean }>Euclidean</option>
            </select>*/}

            <textarea
                className="border flex-1 p-2"
                onChange={ onParametersChange }
                value={ jsonStringify(params) }
            />
        </div>
    )
};

export default KnnParameters;